import { createAction } from '@reduxjs/toolkit';
export const DELETE_MESSAGE_SESSION = 'DELETE_MESSAGE_SESSION';
export const deleteMessageSessionAction = createAction(DELETE_MESSAGE_SESSION, (messageSessionId) => ({
  payload: { messageSessionId }
}));